import { useContext } from "react";
import { ModalsContext } from "./ModalsContext";

export interface ModalsContextType {
  showSettings: boolean;
  setShowSettings: (show: boolean | ((prev: boolean) => boolean)) => void;
  showFocus: boolean;
  setShowFocus: (show: boolean) => void;
  showShortcuts: boolean;
  setShowShortcuts: (show: boolean | ((prev: boolean) => boolean)) => void;
  showAdmin: boolean;
  setShowAdmin: (show: boolean) => void;
  showAchievements: boolean;
  setShowAchievements: (show: boolean) => void;
  showTutorial: boolean;
  setShowTutorial: (show: boolean) => void;
  showTimerSettings: boolean;
  setShowTimerSettings: (show: boolean) => void;
  showTemplates: boolean;
  setShowTemplates: (show: boolean) => void;
  showBugReport: boolean;
  setShowBugReport: (show: boolean) => void;
  settingsScrollTarget: string | null;
  setSettingsScrollTarget: (target: string | null) => void;
}

export function useModals(): ModalsContextType {
  const context = useContext(ModalsContext);
  if (!context) {
    throw new Error("useModals must be used within ModalsProvider");
  }
  return context;
}
